import { Entity, JoinColumn, ManyToMany, OneToMany, OneToOne, PrimaryGeneratedColumn } from "typeorm";
import { Client } from "./Client";
import { KamiTarget } from "./KamiTarget";

@Entity()
export class KamiClient {
  @PrimaryGeneratedColumn({ name:"id" })
  id?: number;

  @ManyToMany(() => Client, (client) => client.kamiClients)
  clients?: Client[]

  @OneToMany(() => KamiTarget, (target) => target.kamiClient, { cascade: true })
  targets?: KamiTarget[]

  @OneToOne(() => Client)
  @JoinColumn()
  source?: Client
}